<template>
  <div>
    <van-popup v-model="isShow" position="bottom" @click-overlay="onCancel">
      <van-datetime-picker v-model="currentDate" type="date" :min-date="minDate" :max-date="maxDate" :formatter="formatter" @cancel="onCancel" @confirm="onConfirm" />
    </van-popup>
  </div>
</template>

<script>
import utils from '@/utils/tradeDataUtil'
export default {
  name: 'Time',
  props: ['show'],
  data() {
    return {
      isShow: this.show,
      currentDate: new Date(),
      minDate: new Date(utils.getLast3Month(new Date()).beginTime),
      maxDate: new Date()
    }
  },
  methods: {
    formatter(type, value) {
      if (type === 'year') {
        return `${value}年`
      } else if (type === 'month') {
        return `${value}月`
      } else if (type === 'day') {
        return `${value}日`
      }
      return value
    },
    onCancel() {
      this.isShow = false
      this.$emit('cancel', this.isShow)
    },
    onConfirm(value) {
      this.isShow = false
      this.$emit('cancel', this.isShow)
      this.$emit('change', value)
    }
  }
}
</script>
